export const iconsByType: Record<string, string> = {

  adf: "/icons/adf.svg",
  db: "/icons/db.svg",
  kv: "/icons/kv.svg",
  vm: "/icons/vm.svg",
  BlobStorage: "/icons/blobstorage.svg",

"access_context_manager": "/icons/gcp/access_context_manager.svg",
"administration": "/icons/gcp/administration.svg",
"advanced_agent_modeling": "/icons/gcp/advanced_agent_modeling.svg",
"advanced_solutions_lab": "/icons/gcp/advanced_solutions_lab.svg",
"agent_assist": "/icons/gcp/agent_assist.svg",
"ai_hub": "/icons/gcp/ai_hub.svg",
"ai_platform": "/icons/gcp/ai_platform.svg",
"ai_platform_unified": "/icons/gcp/ai_platform_unified.svg",
"analytics_hub": "/icons/gcp/analytics_hub.svg",
"anthos": "/icons/gcp/anthos.svg",
"anthos_config_management": "/icons/gcp/anthos_config_management.svg",
"anthos_service_mesh": "/icons/gcp/anthos_service_mesh.svg",
"api": "/icons/gcp/api.svg",
"apigee_api_platform": "/icons/gcp/apigee_api_platform.svg",
"apigee_sense": "/icons/gcp/apigee_sense.svg",
"api_analytics": "/icons/gcp/api_analytics.svg",
"api_monetization": "/icons/gcp/api_monetization.svg",
"app_engine": "/icons/gcp/app_engine.svg",
"artifact_registry": "/icons/gcp/artifact_registry.svg",
"asset_inventory": "/icons/gcp/asset_inventory.svg",
"assured_workloads": "/icons/gcp/assured_workloads.svg",
"automl": "/icons/gcp/automl.svg",
"automl_natural_language": "/icons/gcp/automl_natural_language.svg",
"automl_tables": "/icons/gcp/automl_tables.svg",
"automl_translation": "/icons/gcp/automl_translation.svg",
"automl_video_intelligence": "/icons/gcp/automl_video_intelligence.svg",
"automl_vision": "/icons/gcp/automl_vision.svg",
"bare_metal_solutions": "/icons/gcp/bare_metal_solutions.svg",
"batch": "/icons/gcp/batch.svg",
"beyondcorp": "/icons/gcp/beyondcorp.svg",
"bigquery": "/icons/gcp/bigquery.svg",
"bigtable": "/icons/gcp/bigtable.svg",
"billing": "/icons/gcp/billing.svg",
"binary_authorization": "/icons/gcp/binary_authorization.svg",
"catalog": "/icons/gcp/catalog.svg",
"certificate_authority_service": "/icons/gcp/certificate_authority_service.svg",
"certificate_manager": "/icons/gcp/certificate_manager.svg",
"cloud_apis": "/icons/gcp/cloud_apis.svg",
"cloud_api_gateway": "/icons/gcp/cloud_api_gateway.svg",
"cloud_armor": "/icons/gcp/cloud_armor.svg",
"cloud_asset_inventory": "/icons/gcp/cloud_asset_inventory.svg",
"cloud_audit_logs": "/icons/gcp/cloud_audit_logs.svg",
"cloud_build": "/icons/gcp/cloud_build.svg",
"cloud_cdn": "/icons/gcp/cloud_cdn.svg",
"cloud_code": "/icons/gcp/cloud_code.svg",
"cloud_composer": "/icons/gcp/cloud_composer.svg",
"cloud_data_fusion": "/icons/gcp/cloud_data_fusion.svg",
"cloud_deploy": "/icons/gcp/cloud_deploy.svg",
"cloud_deployment_manager": "/icons/gcp/cloud_deployment_manager.svg",
"cloud_dns": "/icons/gcp/cloud_dns.svg",
"cloud_domains": "/icons/gcp/cloud_domains.svg",
"cloud_ekm": "/icons/gcp/cloud_ekm.svg",
"cloud_endpoints": "/icons/gcp/cloud_endpoints.svg",
"cloud_external_ip_addresses": "/icons/gcp/cloud_external_ip_addresses.svg",
"cloud_firewall_rules": "/icons/gcp/cloud_firewall_rules.svg",
"cloud_for_marketing": "/icons/gcp/cloud_for_marketing.svg",
"cloud_functions": "/icons/gcp/cloud_functions.svg",
"cloud_generic": "/icons/gcp/cloud_generic.svg",
"cloud_gpu": "/icons/gcp/cloud_gpu.svg",
"cloud_healthcare_api": "/icons/gcp/cloud_healthcare_api.svg",
"cloud_healthcare_marketplace": "/icons/gcp/cloud_healthcare_marketplace.svg",
"cloud_hsm": "/icons/gcp/cloud_hsm.svg",
"cloud_ids": "/icons/gcp/cloud_ids.svg",
"cloud_inference_api": "/icons/gcp/cloud_inference_api.svg",
"cloud_interconnect": "/icons/gcp/cloud_interconnect.svg",
"cloud_jobs_api": "/icons/gcp/cloud_jobs_api.svg",
"cloud_load_balancing": "/icons/gcp/cloud_load_balancing.svg",
"cloud_logging": "/icons/gcp/cloud_logging.svg",
"cloud_media_edge": "/icons/gcp/cloud_media_edge.svg",
"cloud_monitoring": "/icons/gcp/cloud_monitoring.svg",
"cloud_nat": "/icons/gcp/cloud_nat.svg",
"cloud_natural_language_api": "/icons/gcp/cloud_natural_language_api.svg",
"cloud_network": "/icons/gcp/cloud_network.svg",
"cloud_ops": "/icons/gcp/cloud_ops.svg",
"cloud_optimization_ai": "/icons/gcp/cloud_optimization_ai.svg",
"cloud_optimization_ai_-_fleet_routing_api": "/icons/gcp/cloud_optimization_ai_-_fleet_routing_api.svg",
"cloud_router": "/icons/gcp/cloud_router.svg",
"cloud_routes": "/icons/gcp/cloud_routes.svg",
"cloud_run": "/icons/gcp/cloud_run.svg",
"cloud_run_for_anthos": "/icons/gcp/cloud_run_for_anthos.svg",
"cloud_scheduler": "/icons/gcp/cloud_scheduler.svg",
"cloud_security_scanner": "/icons/gcp/cloud_security_scanner.svg",
"cloud_shell": "/icons/gcp/cloud_shell.svg",
"cloud_spanner": "/icons/gcp/cloud_spanner.svg",
"cloud_sql": "/icons/gcp/cloud_sql.svg",
"cloud_storage": "/icons/gcp/cloud_storage.svg",
"cloud_tasks": "/icons/gcp/cloud_tasks.svg",
"cloud_test_lab": "/icons/gcp/cloud_test_lab.svg",
"cloud_tpu": "/icons/gcp/cloud_tpu.svg",
"cloud_translation_api": "/icons/gcp/cloud_translation_api.svg",
"cloud_vision_api": "/icons/gcp/cloud_vision_api.svg",
"cloud_vpn": "/icons/gcp/cloud_vpn.svg",
"compute_engine": "/icons/gcp/compute_engine.svg",
"configuration_management": "/icons/gcp/configuration_management.svg",
"connectivity_test": "/icons/gcp/connectivity_test.svg",
"connectors": "/icons/gcp/connectors.svg",
"contact_center_ai": "/icons/gcp/contact_center_ai.svg",
"container_optimized_os": "/icons/gcp/container_optimized_os.svg",
"container_registry": "/icons/gcp/container_registry.svg",
"database_migration_service": "/icons/gcp/database_migration_service.svg",
"dataflow": "/icons/gcp/dataflow.svg",
"datalab": "/icons/gcp/datalab.svg",
"dataplex": "/icons/gcp/dataplex.svg",
"datapol": "/icons/gcp/datapol.svg",
"dataprep": "/icons/gcp/dataprep.svg",
"dataproc": "/icons/gcp/dataproc.svg",
"dataproc_metastore": "/icons/gcp/dataproc_metastore.svg",
"datashare": "/icons/gcp/datashare.svg",
"datastore": "/icons/gcp/datastore.svg",
"datastream": "/icons/gcp/datastream.svg",
"data_catalog": "/icons/gcp/data_catalog.svg",
"data_labeling": "/icons/gcp/data_labeling.svg",
"data_layers": "/icons/gcp/data_layers.svg",
"data_loss_prevention_api": "/icons/gcp/data_loss_prevention_api.svg",
"data_qna": "/icons/gcp/data_qna.svg",
"data_studio": "/icons/gcp/data_studio.svg",
"data_transfer": "/icons/gcp/data_transfer.svg",
"debugger": "/icons/gcp/debugger.svg",
"developer_portal": "/icons/gcp/developer_portal.svg",
"dialogflow": "/icons/gcp/dialogflow.svg",
"dialogflow_cx": "/icons/gcp/dialogflow_cx.svg",
"dialogflow_insights": "/icons/gcp/dialogflow_insights.svg",
"document_ai": "/icons/gcp/document_ai.svg",
"early_access_center": "/icons/gcp/early_access_center.svg",
"error_reporting": "/icons/gcp/error_reporting.svg",
"eventarc": "/icons/gcp/eventarc.svg",
"filestore": "/icons/gcp/filestore.svg",
"financial_services_marketplace": "/icons/gcp/financial_services_marketplace.svg",
"firestore": "/icons/gcp/firestore.svg",
"fleet_engine": "/icons/gcp/fleet_engine.svg",
"free_trial": "/icons/gcp/free_trial.svg",
"game_servers": "/icons/gcp/game_servers.svg",
"gce_systems_management": "/icons/gcp/gce_systems_management.svg",
"genomics": "/icons/gcp/genomics.svg",
"gke_on-prem": "/icons/gcp/gke_on-prem.svg",
"google_cloud_marketplace": "/icons/gcp/google_cloud_marketplace.svg",
"google_kubernetes_engine": "/icons/gcp/google_kubernetes_engine.svg",
"google_maps_platform": "/icons/gcp/google_maps_platform.svg",
"healthcare_nlp_api": "/icons/gcp/healthcare_nlp_api.svg",
"home": "/icons/gcp/home.svg",
"identity-aware_proxy": "/icons/gcp/identity-aware_proxy.svg",
"identity_and_access_management": "/icons/gcp/identity_and_access_management.svg",
"identity_platform": "/icons/gcp/identity_platform.svg",
"iot_core": "/icons/gcp/iot_core.svg",
"iot_edge": "/icons/gcp/iot_edge.svg",
"key_access_justifications": "/icons/gcp/key_access_justifications.svg",
"key_management_service": "/icons/gcp/key_management_service.svg",
"kuberun": "/icons/gcp/kuberun.svg",
"launcher": "/icons/gcp/launcher.svg",
"local_ssd": "/icons/gcp/local_ssd.svg",
"looker": "/icons/gcp/looker.svg",
"managed_service_for_microsoft_active_directory": "/icons/gcp/managed_service_for_microsoft_active_directory.svg",
"media_translation_api": "/icons/gcp/media_translation_api.svg",
"memorystore": "/icons/gcp/memorystore.svg",
"migrate_for_anthos": "/icons/gcp/migrate_for_anthos.svg",
"migrate_for_compute_engine": "/icons/gcp/migrate_for_compute_engine.svg",
"my_cloud": "/icons/gcp/my_cloud.svg",
"network_connectivity_center": "/icons/gcp/network_connectivity_center.svg",
"network_intelligence_center": "/icons/gcp/network_intelligence_center.svg",
"network_security": "/icons/gcp/network_security.svg",
"network_tiers": "/icons/gcp/network_tiers.svg",
"network_topology": "/icons/gcp/network_topology.svg",
"onboarding": "/icons/gcp/onboarding.svg",
"os_configuration_management": "/icons/gcp/os_configuration_management.svg",
"os_inventory_management": "/icons/gcp/os_inventory_management.svg",
"os_patch_management": "/icons/gcp/os_patch_management.svg",
"partner_interconnect": "/icons/gcp/partner_interconnect.svg",
"partner_portal": "/icons/gcp/partner_portal.svg",
"performance_dashboard": "/icons/gcp/performance_dashboard.svg",
"permissions": "/icons/gcp/permissions.svg",
"persistent_disk": "/icons/gcp/persistent_disk.svg",
"phishing_protection": "/icons/gcp/phishing_protection.svg",
"policy_analyzer": "/icons/gcp/policy_analyzer.svg",
"premium_network_tier": "/icons/gcp/premium_network_tier.svg",
"private_connectivity": "/icons/gcp/private_connectivity.svg",
"private_service_connect": "/icons/gcp/private_service_connect.svg",
"producer_portal": "/icons/gcp/producer_portal.svg",
"profiler": "/icons/gcp/profiler.svg",
"project": "/icons/gcp/project.svg",
"pubsub": "/icons/gcp/pubsub.svg",
"quantum_engine": "/icons/gcp/quantum_engine.svg",
"quotas": "/icons/gcp/quotas.svg",
"real-world_insights": "/icons/gcp/real-world_insights.svg",
"recommendations_ai": "/icons/gcp/recommendations_ai.svg",
"release_notes": "/icons/gcp/release_notes.svg",
"retail_api": "/icons/gcp/retail_api.svg",
"risk_manager": "/icons/gcp/risk_manager.svg",
"runtime_config": "/icons/gcp/runtime_config.svg",
"secret_manager": "/icons/gcp/secret_manager.svg",
"security": "/icons/gcp/security.svg",
"security_command_center": "/icons/gcp/security_command_center.svg",
"security_health_advisor": "/icons/gcp/security_health_advisor.svg",
"security_key_enforcement": "/icons/gcp/security_key_enforcement.svg",
"service_discovery": "/icons/gcp/service_discovery.svg",
"speech-to-text": "/icons/gcp/speech-to-text.svg",
"stackdriver": "/icons/gcp/stackdriver.svg",
"standard_network_tier": "/icons/gcp/standard_network_tier.svg",
"stream_suite": "/icons/gcp/stream_suite.svg",
"support": "/icons/gcp/support.svg",
"tensorflow_enterprise": "/icons/gcp/tensorflow_enterprise.svg",
"text-to-speech": "/icons/gcp/text-to-speech.svg",
"tools_for_powershell": "/icons/gcp/tools_for_powershell.svg",
"trace": "/icons/gcp/trace.svg",
"traffic_director": "/icons/gcp/traffic_director.svg",
"transfer": "/icons/gcp/transfer.svg",
"transfer_appliance": "/icons/gcp/transfer_appliance.svg",
"user_preferences": "/icons/gcp/user_preferences.svg",
"vertexai": "/icons/gcp/vertexai.svg",
"video_intelligence_api": "/icons/gcp/video_intelligence_api.svg",
"virtual_private_cloud": "/icons/gcp/virtual_private_cloud.svg",
"visual_inspection": "/icons/gcp/visual_inspection.svg",
"vmware_engine": "/icons/gcp/vmware_engine.svg",
"web_risk": "/icons/gcp/web_risk.svg",
"web_security_scanner": "/icons/gcp/web_security_scanner.svg",
"workflows": "/icons/gcp/workflows.svg",
"workload_identity_pool": "/icons/gcp/workload_identity_pool.svg"
};